import { Picture, Source, Img } from "@xo-union/tk-component-picture";
import CONFETTI_BACKGROUND_SIZE from "../../constants/confettiBackgroundSize.js";
import getConfettiSetId from "../../utils/getConfettiSetId.js";
import styles from "./styles.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ConfettiBackground = function ConfettiBackground(_ref) {
  var set = _ref.set;
  return /*#__PURE__*/_jsx("div", {
    className: styles.confettiBackground,
    children: /*#__PURE__*/_jsxs(Picture, {
      preload: true,
      children: [/*#__PURE__*/_jsx(Source, {
        id: getConfettiSetId(set).mobile,
        viewport: "xs",
        width: CONFETTI_BACKGROUND_SIZE.xs.width,
        height: CONFETTI_BACKGROUND_SIZE.xs.height
      }), /*#__PURE__*/_jsx(Source, {
        id: getConfettiSetId(set).tablet,
        viewport: "md",
        width: CONFETTI_BACKGROUND_SIZE.md.width,
        height: CONFETTI_BACKGROUND_SIZE.md.height
      }), /*#__PURE__*/_jsx(Source, {
        id: getConfettiSetId(set).tablet,
        viewport: "lg",
        width: CONFETTI_BACKGROUND_SIZE.lg.width,
        height: CONFETTI_BACKGROUND_SIZE.lg.height
      }), /*#__PURE__*/_jsx(Source, {
        id: getConfettiSetId(set).desktop,
        viewport: "xl",
        width: CONFETTI_BACKGROUND_SIZE.xl.width,
        height: CONFETTI_BACKGROUND_SIZE.xl.height
      }), /*#__PURE__*/_jsx(Img, {
        id: getConfettiSetId(set).desktop,
        width: CONFETTI_BACKGROUND_SIZE.lg.width,
        height: CONFETTI_BACKGROUND_SIZE.lg.height,
        alt: ""
      })]
    })
  });
};
export default ConfettiBackground;